import React, { PropsWithChildren, Suspense } from 'react';
import { ModalContainer, ModalLayout, ModalLayoutTokens } from '@cp/ds/src/components/modalLayout';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { IModalWrapperProps } from './modal.interface';
import { ModalErrorBoundary } from './errorBoundary';

const Dialog = React.lazy(() => import('@mui/material/Dialog'));

export interface IDialogModalProps extends PropsWithChildren, IModalWrapperProps {}
export const DialogModal: React.FC<IDialogModalProps> = ({ ContentComponent, contentProps, open, onClose, onClosed }) => {
  return (
    <Suspense fallback={null}>
      <Dialog
        PaperProps={{
          sx: {
            borderRadius: ModalLayoutTokens.Radius(),
            backgroundColor: ModalLayoutTokens.PaperColor(),
            overflow: 'visible',
            maxWidth: 'none',
          },
        }}
        TransitionProps={{ onExited: onClosed }}
        onClose={onClose}
        open={open}
        sx={{ zIndex: 50 }}
        transitionDuration={300}
      >
        <ModalErrorBoundary>
          <Suspense
            fallback={
              <ModalLayout>
                <ModalContainer>
                  <ContentSkeleton blocks={2} />
                </ModalContainer>
              </ModalLayout>
            }
          >
            <ContentComponent {...contentProps} />
          </Suspense>
        </ModalErrorBoundary>
      </Dialog>
    </Suspense>
  );
};
